import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { IndentDTO, IndentRequest } from "./dto/indent-data.request";
import { PlantIdRequest } from "./dto/indent-drop-down.request";
import { IndentFormDto } from "./dto/indent-form.dto";
import { PackingIndentService } from "./indent.service";

@Controller('packing-indent')
@ApiTags('packing-indent')

export class PackingIndentController {
  constructor(
    private packingIndentService: PackingIndentService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) { }

    @Post('/getIndentDataByIndentNumber')
    async getIndentDataByIndentNumber(@Body() req:IndentDTO): Promise<CommonResponse> {
        try {
            return await this.packingIndentService.getIndentDataByIndentNumber(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    
    @Post('CreateIndentFormEntry')
    async CreateIndentFormEntry(@Body() dto:IndentFormDto) :Promise<CommonResponse>{
        try{
            return await this.packingIndentService.CreateIndentFormEntry(dto,false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error)
        }
    }
    @Post('/getindentbarcodedetails')
    async getindentbarcodedetails(): Promise<CommonResponse>  {
        try {             
           return await this.packingIndentService.getindentbarcodedetails();
        } catch (error) {
           return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    
    @Post('/updateReceivedQuantity')
    async updateReceivedQuantity(@Body() req: IndentRequest): Promise<CommonResponse> {
        try {
            return await this.packingIndentService.updateReceivedQuantity(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    
    @Post('/getReceivedQuantityagainstPonumber')
    async getReceivedQuantityagainstPonumber(@Body() req: IndentDTO): Promise<CommonResponse> {
        try {
            return await this.packingIndentService.getReceivedQuantityagainstPonumber(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/updateIssuedQuantity')
    async updateIssuedQuantity(@Body() req: IndentRequest): Promise<CommonResponse> {
        try {
            return await this.packingIndentService.updateIssuedQuantity(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getIndentDropDownData')
    async getIndentDropDownData(@Body() req: PlantIdRequest): Promise<CommonResponse> {
        try {
            return await this.packingIndentService.getIndentDropDownData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}